import Vue from 'vue'
import Vuex from 'vuex'
import {transportistaCollection} from '@/FirebaseConfig'
import {cleanObject, secondsToFullTimestamp} from '@/Helper.js'  
Vue.use(Vuex)
export default {
    namespaced:true,
      state: {
        datos:{
          nombre:'',
          descripción:'',
          documento:'',
          placas:[],
          creado_el:'',
        },
        registro:{},
        selectedKey: '',
        dialog: false,
      },
      mutations: {
        getAllItems(state, item) {
          Vue.set( state.registro, item.id, {...item.data(), creado_el: secondsToFullTimestamp(item.data().creado_el)} )
        },
        clean(state,key){
          Vue.delete(state.registro,key)
        }
      },
      actions: {
        
        getAll:(context)=>{
          context.state.registro = {}
          transportistaCollection.onSnapshot(datos=>datos.docs.map( item => {context.commit( 'getAllItems', item  ) }) )
        },
        add:context=>{
          
          if(context.state.selectedKey==''){
            transportistaCollection.add({...context.state.datos, creado_el:new Date}).then(()=>{
              context.commit('Helpers/launchSnackbar', 'Se ha registrado un nuevo transportita correctamente', { root: true })
              cleanObject(context.state.datos)
              context.state.dialog = false
            })
          }else{
            transportistaCollection.doc(context.state.selectedKey).update(context.state.datos).then(()=>{
              context.commit('Helpers/launchSnackbar', ' Ha sido modificado correctamente', { root: true })
              cleanObject(context.state.datos)
              context.state.dialog = false
            })
          }
        },
        clean:(context, key)=>{
            transportistaCollection.doc(key).delete().then(()=>{
            context.commit('Helpers/launchSnackbar', ' Ha sido eliminado', { root: true })            
            context.commit('clean',key)})
        },
        get:(context, key)=>{
            transportistaCollection.doc(key).get().then(doc=>{
            context.state.datos = doc.data()
            context.state.selectedKey = key
            context.state.dialog = true
          })
        },
        clearForm:(context)=>{
          context.state.dialog = false
          context.state.selectedKey = ''
          context.state.datos = {
            nombre: '',
            descripción:'',
            documento:'',
            placas:[],
            creado_el: ''
          }
        },
      },
      getters: {
        registro: state => Object.keys(state.registro).map(item => ({...state.registro[item], key: item }) ),
      },
  }
  